<template>
    <div class="@font-bold !@text-[13px] @text-sfc-cherry @uppercase !@leading-[16px]">
        only on songfinch
    </div>
</template>
